import { AutomationSdkNx } from '@/components/interactive/components/automation-sdk-nx'
import { CliAutomationSdkHeroVisual } from '@/components/interactive/components/cli-automation-sdk-hero-visual'
import { CodeFirstConfiguration } from '@/components/interactive/components/code-first-configuration'
import { CommerceFrameworkHeroVisual } from '@/components/interactive/components/commerce-framework-hero-visual'
import { cn } from '@/lib/utils'
import React from 'react'

type InteractiveComponent = React.ComponentType<any>

export const components: Record<string, InteractiveComponent> = {
  'commerce-framework-hero-visual': CommerceFrameworkHeroVisual,
  'cli-automation-sdk-hero-visual': CliAutomationSdkHeroVisual,
  'code-first-configuration': CodeFirstConfiguration,
  'automation-sdk-nx': AutomationSdkNx,
}

interface InteractiveVisualProps {
  componentId: string | number
  className?: string
  [key: string]: any
}

export function InteractiveVisual({ componentId, className, ...props }: InteractiveVisualProps) {
  const Component = components[componentId]

  if (!Component) {
    return (
      <div
        className={cn(
          'border-border text-muted-foreground rounded-md border bg-red-600 p-4',
          className,
        )}
      >
        Interactive component not found: {componentId}
      </div>
    )
  }

  return (
    <Component
      className={className}
      {...props}
    />
  )
}
